import { atom } from "recoil";
import { PlanKey } from "../components/task/payment/planTypes";

export interface UserType {
  accessToken?: string;
  role?: string;
  nickname?: string;
  isNicknameChangeRequired?: boolean;
  email?: string;
  userId?: number;
  programStartedAt?: string;
  hasPraised?: boolean;
  surveySeq?: number;
  dayNumber?: number;
  subscription?: {
    hasStarted: boolean;
    isSubscribing: boolean;
    expiryDaysLeft?: number;
    latestPaidAt?: string;
    expirationAt?: string;
    canceledAt?: string; // 인앱결제만
    renewedAt?: string; // 인앱결제만
    bonusDays?: number;
    isFirstSubscription: boolean;
    hasBeenRefunded: boolean;
    hasBeenPlanUpgraded: boolean;
  };
  isMandatoryTaskForRefundDone?: boolean;
  isCoachChanged?: boolean;
  isEarlyAccess?: boolean;
  assignedCoachName?: string;
  isOnboardingRequired?: boolean;
  isCommitmentRequired?: boolean;
  onboardingType?: string;
  benefit?: string;
  appId?: string;
  pricingModel?: string;
  programType?: string;
  lastTaskUpdatedAt?: string;
  todayTaskUpdateCount?: number;
  weeklyTaskUpdateCount?: number;
  isCarePass?: boolean;
  trackId?: string;
  plan?: PlanKey;
  paymentPageType?: string;
  refundPolicyType?: string;
  segmentType?: string;
  isInsider?: boolean;
  isStoreReviewer?: boolean;
  isWebFunnelRegister?: boolean;
  isDemographicRequired?: boolean;
  promotion?: string;
}

export const userAtom = atom<UserType | undefined>({
  key: "user",
  default: undefined,
  effects: [
    ({ setSelf, onSet }) => {
      const savedData = localStorage.getItem("user");
      // setSelf: atom 값을 설정 혹은 재설정
      if (savedData) setSelf(JSON.parse(savedData));

      // atom이 변화가 감지될 때 작동, Storage에 데이터 저장
      // setSelf에 의해서는 작동하지 않음
      onSet((newValue, _, isReset) => {
        isReset
          ? localStorage.removeItem("user")
          : localStorage.setItem("user", JSON.stringify(newValue));
      });
    },
  ],
});
